import { render, staticRenderFns } from "./CreateUpdatePage.vue?vue&type=template&id=c3a30746&scoped=true"
import script from "./CreateUpdatePage.vue?vue&type=script&lang=js"
export * from "./CreateUpdatePage.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdatePage.vue?vue&type=style&index=0&id=c3a30746&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a30746",
  null
  
)

export default component.exports